import React from 'react';
import { Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import FullPageLayout from '../_layout/FullPageLayout/full-page.layout';
import LoadingPage from '../_boilerplate/LoadingPage/loading-page.container';
import { AssignmentScoringGraphQL } from './assignment-scoring.graphql';
import { hasCalibrationAssignmentAccess } from '../../../lib/services/scoring.service';
import { HOME_ROUTE } from '../../../../_configuration';

interface IAssignmentScoringPageProps {
  match: { params: { assignmentId: string } };
}

export const AssignmentScoringPage: React.FC<IAssignmentScoringPageProps> = ({ match }) => {
  const { assignmentId } = match.params;
  const { hasAccess, loading } = hasCalibrationAssignmentAccess();

  if (loading) return <LoadingPage />;
  if (!hasAccess) return <Redirect to={HOME_ROUTE} />;

  return (
    <FullPageLayout>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AssignmentScoringGraphQL assignmentId={assignmentId} />
        </Grid>
      </Grid>
    </FullPageLayout>
  );
};
